const EmpowerSection = ({ language = "EN" }) => {

  const lang = language === "CN" ? "zh" : "en";

  const text = {
    en: {
      title1: "Build a career with",
      title2: "purpose.",
      title3: "Journey with us.",
      p1: "At JT Group, we don’t just offer jobs — we offer a calling. A career in financial advisory is one of the most rewarding paths you can take: you build real expertise, achieve genuine financial independence, and make a meaningful difference in the lives of the people you serve.",
      p2: "Whether you are a fresh graduate, a student exploring your future, or an experienced professional seeking a new direction, there is a place for you here. We welcome ambition from all backgrounds and will walk alongside you every step of the way.",
    },

    zh: {
      title1: "打造有",
      title2: "意义",
      title3: "的事业，与我们同行",
      p1: "在 JT Group，我们不仅提供工作，而是提供使命感。金融顾问是最具回报的职业之一：你可以建立专业能力，实现财务自由，并为客户带来真正的价值。",
      p2: "无论你是毕业生、学生，还是希望转换方向的专业人士，这里都有属于你的位置。我们欢迎来自不同背景的你，并陪伴你成长。",
    },
  };

  return (
    <section className="bg-white py-10">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">

        <div className="grid lg:grid-cols-2 gap-12 items-center">

          {/* LEFT */}
          <div>

           <h2 className="text-[34px] md:text-[34px] font-medium text-[#154059] leading-snug mt-0 text-center md:text-left">
              {text[lang].title1}{" "}
              <span className="text-[#C69C6D]">
                {text[lang].title2}
              </span>{" "}
              {text[lang].title3}
            </h2>

            <p className="text-gray-600 mt-4 text-justify leading-relaxed">
              {text[lang].p1}
            </p>

            <p className="text-gray-600 mt-4 text-justify leading-relaxed">
              {text[lang].p2}
            </p>

          </div>


          {/* RIGHT */}
          <div className="relative">

            <img
              src="/assets/images/JTG-Group-4-scaled-e1755680803447-1536x752%20(1).jpg"
              alt=""
              className="w-full h-full object-cover shadow-lg"
            />

          </div>

        </div>

      </div>
    </section>
  );
};

export default EmpowerSection;